<script>
	import VueContentLoading from "vue-content-loading";
	export default {
		components: { VueContentLoading }
	};
</script>

<template>
	<div class="panel panel-default filtro">
		<vue-content-loading :width="846" :height="50">
			<rect x="0" y="0" width="846" height="50" />
		</vue-content-loading>
	</div>
</template>

<style scoped>
    .filtro {border: 0; overflow: hidden;position: relative; box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;}
    .filtro svg {display: block;}
</style>